import React from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import Icon from "@mui/material/Icon";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import FileInput from "./FileInput";

import Moment from "react-moment";
import DataTable from "examples/Tables/DataTable";

import { API_URL } from "../../../config/apiUrl";

import { putDevice, getDevice } from "../../../api/devices";

import DeleteModal from "../DeleteModal";

import { getOrder } from "../../../api/orders";

import { useDispatch, useSelector } from "react-redux";

import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import EditControl from "../EditControl";

export default function ControlTable({ device, user }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const dispatch = useDispatch();

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  const crfinal = `${API_URL}files/${device.cr_inspection_filename}?api_key=${
    process.env.REACT_APP_NGT_API_KEY
  }&session_token=${localStorage.getItem("sessionToken")}`;

  const reserves = `${API_URL}files/${device.reserves_filename}?api_key=${
    process.env.REACT_APP_NGT_API_KEY
  }&session_token=${localStorage.getItem("sessionToken")}`;

  const attfinal = `${API_URL}files/${device.att_inspection_filename}?api_key=${
    process.env.REACT_APP_NGT_API_KEY
  }&session_token=${localStorage.getItem("sessionToken")}`;

  const ue = `${API_URL}files/${device.ue_declaration_filename}?api_key=${
    process.env.REACT_APP_NGT_API_KEY
  }&session_token=${localStorage.getItem("sessionToken")}`;

  async function updateDeviceAPI(device, deviceId) {
    await putDevice(device, deviceId);
    const orderResponse = await getOrder(currentOrder.order_id);
    dispatch(setCurrentOrder(orderResponse.data));
    const deviceResponse = await getDevice(deviceId);
    return await deviceResponse.data;
  }

  const contractColumns = [
    { Header: "Contrôle CE", accessor: "organism", align: "center" },
    { Header: "Compte rendu d'inspection finale", accessor: "crfinal", align: "center" },
    { Header: "Levée des réserves", accessor: "reserves", align: "center" },
    { Header: "Attestation d'inspection finale", accessor: "attfinal", align: "center" },
    { Header: "Déclaration de conformité UE", accessor: "ue", align: "center" },
  ];

  const contractRows = [
    {
      organism: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.ce_control_date ? (
            <MDBox lineHeight={1}>
              <MDTypography variant="caption">Réalisé le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">{device && device.ce_control_date}</Moment>
              </MDTypography>
              <MDTypography variant="caption">par</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                {device && device.organism_name}
              </MDTypography>
            </MDBox>
          ) : (
            <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
              Non réalisé
            </MDTypography>
          )}
        </MDBox>
      ),
      crfinal: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.cr_inspection_filename ? (
            <MDBox sx={{ alignText: "center" }}>
              <MDBox lineHeight={1}>
                <a href={crfinal} download>
                  <MDTypography
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      display: "table-cell",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                    display="block"
                    variant="body2"
                    fontWeight="medium"
                    underline="hover"
                  >
                    <Icon sx={{ verticalAlign: "middle" }}>download</Icon>{" "}
                    {device.cr_inspection_filename}
                  </MDTypography>
                </a>
              </MDBox>
              {user &&
                (user.role === "Contremaître" ||
                  user.role === "Chef d'agence" ||
                  user.role === "Admin" ||
                  user.role === "Pilote") && (
                  <DeleteModal
                    message={`ce fichier`}
                    onOk={() => {
                      fetch(`${API_URL}files/${device.cr_inspection_filename}`, {
                        method: "DELETE",
                        headers: {
                          "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                          Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                        },
                      });
                      updateDeviceAPI(
                        {
                          cr_inspection_filename: null,
                        },
                        device.device_id
                      );
                    }}
                    type="file"
                  />
                )}
            </MDBox>
          ) : (
            <FileInput device={device} fileDescription="-cr-inspection-finale" />
          )}
        </MDBox>
      ),
      reserves: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.reserves_filename ? (
            <MDBox sx={{ alignText: "center" }}>
              <MDBox lineHeight={1}>
                <a href={reserves} download>
                  <MDTypography
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      display: "table-cell",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                    display="block"
                    variant="body2"
                    fontWeight="medium"
                    underline="hover"
                  >
                    <Icon sx={{ verticalAlign: "middle" }}>download</Icon>{" "}
                    {device.reserves_filename}
                  </MDTypography>
                </a>
              </MDBox>
              {user &&
                (user.role === "Contremaître" ||
                  user.role === "Chef d'agence" ||
                  user.role === "Admin" ||
                  user.role === "Pilote") && (
                  <DeleteModal
                    message={`ce fichier`}
                    onOk={() => {
                      fetch(`${API_URL}files/${device.reserves_filename}`, {
                        method: "DELETE",
                        headers: {
                          "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                          Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                        },
                      });
                      updateDeviceAPI(
                        {
                          reserves_filename: null,
                        },
                        device.device_id
                      );
                    }}
                    type="file"
                  />
                )}
            </MDBox>
          ) : (
            <FileInput device={device} fileDescription="-levée-réserves" />
          )}
        </MDBox>
      ),
      attfinal: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.att_inspection_filename ? (
            <MDBox sx={{ alignText: "center" }}>
              <MDBox lineHeight={1}>
                <a href={attfinal} download>
                  <MDTypography
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      display: "table-cell",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                    display="block"
                    variant="body2"
                    fontWeight="medium"
                    underline="hover"
                  >
                    <Icon sx={{ verticalAlign: "middle" }}>download</Icon>{" "}
                    {device.att_inspection_filename}
                  </MDTypography>
                </a>
              </MDBox>
              {user &&
                (user.role === "Contremaître" ||
                  user.role === "Chef d'agence" ||
                  user.role === "Admin" ||
                  user.role === "Pilote") && (
                  <DeleteModal
                    message={`ce fichier`}
                    onOk={() => {
                      fetch(`${API_URL}files/${device.att_inspection_filename}`, {
                        method: "DELETE",
                        headers: {
                          "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                          Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                        },
                      });
                      updateDeviceAPI(
                        {
                          att_inspection_filename: null,
                        },
                        device.device_id
                      );
                    }}
                    type="file"
                  />
                )}
            </MDBox>
          ) : (
            <FileInput device={device} fileDescription="-att-inspection-finale" />
          )}
        </MDBox>
      ),
      ue: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.ue_declaration_filename ? (
            <MDBox sx={{ alignText: "center" }}>
              <MDBox lineHeight={1}>
                <a href={ue} download>
                  <MDTypography
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      display: "table-cell",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                    display="block"
                    variant="body2"
                    fontWeight="medium"
                    underline="hover"
                  >
                    <Icon sx={{ verticalAlign: "middle" }}>download</Icon>{" "}
                    {device.ue_declaration_filename}
                  </MDTypography>
                </a>
              </MDBox>
              {user &&
                (user.role === "Contremaître" ||
                  user.role === "Chef d'agence" ||
                  user.role === "Admin" ||
                  user.role === "Pilote") && (
                  <DeleteModal
                    message={`ce fichier`}
                    onOk={() => {
                      fetch(`${API_URL}files/${device.ue_declaration_filename}`, {
                        method: "DELETE",
                        headers: {
                          "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                          Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                        },
                      });
                      updateDeviceAPI(
                        {
                          ue_declaration_filename: null,
                        },
                        device.device_id
                      );
                    }}
                    type="file"
                  />
                )}
            </MDBox>
          ) : (
            <FileInput device={device} fileDescription="-déclaration-UE" />
          )}
        </MDBox>
      ),
    },
  ];

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} height="100%">
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "85%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Contrôle CE
          </MDTypography>
          {user &&
            (user.role === "Contremaître" ||
              user.role === "Chef d'agence" ||
              user.role === "Admin" ||
              user.role === "Pilote") && (
              <Grid style={{ textAlign: "right", width: "15%" }}>
                <EditControl device={device} edit={true} />
              </Grid>
            )}
        </MDBox>
        <MDBox
          pt={0.75}
          sx={{
            height: "100%",
            "div.MuiTableContainer-root": {
              height: "100%",
              display: "flex",
            },
          }}
        >
          <DataTable
            table={{ columns: contractColumns, rows: contractRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </Grid>
  );
}
